import { createStore } from "vuex";
import modalStore from "@/store/modules/local/modalStore";
import notificationStore from "@/store/modules/local/notificationStore";
import orderStore from "@/store/modules/api/order/orderStore";
import authStore from "@/store/modules/api/userManagement/authStore";
import userStore from "@/store/modules/api/userManagement/userStore";
import settingStore from "@/store/modules/api/setting/settingStore";

export default createStore({
  modules: {
    modal: modalStore,
    notification: notificationStore,
    order: orderStore,
    auth: authStore,
    user: userStore,
    setting: settingStore,
  },
});
